import { Theme } from 'config';

const styles = (theme: Theme) => ({
  card: {
    minHeight: '11.875rem !important',
    width: '100% !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    borderRight: '.0625rem  solid #f7f7f7 !important',
    transform: 'none !important',
  },
  header: {
    padding: '1em !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05)',
    color: '#440C7F !important',
    fontWeight: 'bold' as const,
  },
  description: {
    padding: '.75rem !important',
    color: '#797979 !important',
    fontSize: '.875rem !important',
    lineHeight: '2em !important',
  },
  icon: {
    height: '1.6875em !important',
    width: '1.6875em !important',
    marginRight: '.5em !important',
  },
  cnCard: {
    padding: '0 !important',
    margin: '0 .75rem !important',
    '&:first-child': {
      marginLeft: '0 !important',
    },
    '&:last-child': {
      marginRight: '0 !important',
    },
  },
  label: {
    fontSize: '.75rem !important',
  },
  value: {
    fontSize: '.875rem !important',
    fontWeight: 'bold',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  cardNetwork: {
    fontWeight: '500 !important',
  },
  button: {
    margin: '.5rem .375rem !important',
    backgroundColor: `${theme.violet} !important`,
    borderRadius: '1.5rem !important',
    color: '#fff !important',
    fontSize: '.8rem !important',
    padding: '0.4rem 0.75rem !important',
    fontWeight: '500 !important',
    lineHeight: '1.25rem !important',

    '&.activation': {
      backgroundColor: `${theme.seafoamGreen} !important`,
    },
    '&.deactivation': {
      backgroundColor: `${theme.coral} !important`,
    },
    '&.tier1': {
      backgroundColor: `${theme.deepPurple} !important`,
    },
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  disabled: {
    backgroundColor: `${theme.softGray} !important`,
    opacity: '.45 !important',
    color: `${theme.darkGray} !important`,
    pointerEvents: 'none',
  },
  actions: {
    padding: '0 !important',
  },
  formSelect: {
    margin: '0 !important',
  },
  '@global i.arrow.up': {
    marginLeft: '0.25em',
    marginRight: '0',
  },
  '@global i.arrow.down': {
    marginLeft: '0.25em',
    marginRight: '0',
  },
});

export default styles;
